import React, { useContext } from 'react'

import PropTypes from 'prop-types'
import { ThemeContext } from 'styled-components'

import icons from '../../../svg/icons/icon-map'

const Icon = ({ className, name, size, color, ...props }) => {
  const theme = useContext(ThemeContext)

  if (!icons[name]) return null

  const Icon = icons[name]

  return (
    <Icon
      className={`icon ${className}`}
      color={theme.color[color]}
      style={{ width: size, height: size, flexShrink: 0 }}
      {...props}
    />
  )
}

Icon.defaultProps = {
  className: '',
  size: 32,
  color: 'neutral500'
}

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string
}

export default Icon
